import { useEffect, useState } from "react";
import { ContractorCompaniesWithThresholdsResponse } from "../interface/api/ContractorCompaniesWithThresholdsResponse";
import { TransportCompany } from "../interface/api/TransportCompany";
import { Truck } from "../interface/api/Truck";
import contractorCompanyService from "../services/contractorCompanyService";
import transportCompanyService from "../services/transportCompanyService";
import truckService from "../services/truckService";

type ContractorFilter = "isSmallQuantity" | "isRubble" | "isHydrovac";

export function useTransportData({
  contractorFilter,
  loadTrucks = true,
}: {
  contractorFilter: ContractorFilter;
  loadTrucks?: boolean;
}) {
  const [contractors, setContractors] = useState<
    { value: number; label: string }[]
  >([]);
  const [transportCompanies, setTransportCompanies] = useState<
    { value: number; label: string }[]
  >([]);
  const [trucks, setTrucks] = useState<Truck[]>([]);

  useEffect(() => {
    contractorCompanyService.getContractorCompanies().then((response) => {
      if (response.ok && response.data) {
        const data = response.data as ContractorCompaniesWithThresholdsResponse;
        const companies = data.contractorCompanies.filter(
          (c) => (c as any)[contractorFilter]
        );
        setContractors(
          companies.map((c) => ({ value: c.id, label: c.name }))
        );
      }
    });
    transportCompanyService.getTransportCompanies().then((response) => {
      if (response.ok && response.data) {
        const companies = response.data as TransportCompany[];
        setTransportCompanies(
          companies.map((c) => ({ value: c.id, label: c.name }))
        );
      }
    });
    if (loadTrucks) {
      truckService
        .getTrucks({ transportCompanyId: null, truck: null, transportContact: null })
        .then((response) => {
          if (response.ok && response.data) {
            setTrucks(response.data as Truck[]);
          }
        });
    }
  }, []);

  return { contractors, transportCompanies, trucks };
}
